import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { Form, IFormContentProps, Field, MultiLineField } from '@gem/components';
import { RadioButtonGroup } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { Button, ButtonTypes, customScrollStyles, Loader, PopupFooter } from '@gem/ui-kit';

import { useReportFormPresenter } from './ReportForm.presenter';
import styles from './ReportForm.styles.m.css';
import { TSubmitHandler } from './ReportForm.types';

const FORM_ID = 'report-form';

interface IReportFormProps {
  title: string;
  onSubmit: TSubmitHandler;
}

export const ReportForm: FC<IReportFormProps> = observer(({ title, onSubmit }) => {
  const presenter = useReportFormPresenter(onSubmit);
  const { t } = useTranslation();

  if (presenter.isLoading) {
    return (
      <Loader
        className={styles.loader}
        color="base"
        size="medium"
      />
    );
  }

  return (
    <Form
      initialValues={presenter.initialValues}
      subscription={{
        submitting: true,
        pristine: true,
      }}
      onSubmit={presenter.onSubmit}
    >
      {({ handleSubmit, submitting, pristine }: IFormContentProps): ReactElement => (
        <>
          <form
            id={FORM_ID}
            className={classNames(styles.form, customScrollStyles.container)}
            onSubmit={handleSubmit}
          >
            <div className={styles.title}>{title}</div>

            <RadioButtonGroup
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              name="reasonId"
              options={presenter.reasons}
            />

            {!pristine && (
              <Field
                className={styles.comment}
                name="comment"
                label={t('content_moderation_comment_placeholder')}
                component={MultiLineField}
              />
            )}
          </form>

          <PopupFooter>
            <Button
              form={FORM_ID}
              type={ButtonTypes.Submit}
              theme="primary"
              isLoading={submitting}
              isDisabled={pristine}
            >
              {t('send')}
            </Button>
          </PopupFooter>
        </>
      )}
    </Form>
  );
});
